import { buildNetlifyCallback } from "@/lib/backend";
import type {
  RoadmapCreateRequest,
  RoadmapCreateResponse,
  RoadmapUpdateRequest,
  RoadmapUpdateResponse,
  RoadmapDeleteRequest,
  RoadmapDeleteResponse,
  SwimlaneCreateRequest,
  SwimlaneCreateResponse,
  SwimlaneUpdateRequest,
  SwimlaneUpdateResponse,
  SwimlaneDeleteRequest,
  SwimlaneDeleteResponse,
  ColumnCreateRequest,
  ColumnCreateResponse,
  ColumnUpdateRequest,
  ColumnUpdateResponse,
  ColumnDeleteRequest,
  ColumnDeleteResponse,
  CardAddRequest,
  CardAddResponse,
  CardMoveRequest,
  CardMoveResponse,
  CardRemoveRequest,
  CardRemoveResponse,
} from "@/types/Roadmap";

export const createRoadmap = buildNetlifyCallback<
  RoadmapCreateRequest,
  RoadmapCreateResponse
>("RoadmapCreate");

export const updateRoadmap = buildNetlifyCallback<
  RoadmapUpdateRequest,
  RoadmapUpdateResponse
>("RoadmapUpdate");

export const deleteRoadmap = buildNetlifyCallback<
  RoadmapDeleteRequest,
  RoadmapDeleteResponse
>("RoadmapDelete");

export const createSwimlane = buildNetlifyCallback<
  SwimlaneCreateRequest,
  SwimlaneCreateResponse
>("RoadmapSwimlaneCreate");

export const updateSwimlane = buildNetlifyCallback<
  SwimlaneUpdateRequest,
  SwimlaneUpdateResponse
>("RoadmapSwimlaneUpdate");

export const deleteSwimlane = buildNetlifyCallback<
  SwimlaneDeleteRequest,
  SwimlaneDeleteResponse
>("RoadmapSwimlaneDelete");

export const createColumn = buildNetlifyCallback<
  ColumnCreateRequest,
  ColumnCreateResponse
>("RoadmapColumnCreate");

export const updateColumn = buildNetlifyCallback<
  ColumnUpdateRequest,
  ColumnUpdateResponse
>("RoadmapColumnUpdate");

export const deleteColumn = buildNetlifyCallback<
  ColumnDeleteRequest,
  ColumnDeleteResponse
>("RoadmapColumnDelete");

export const addCard = buildNetlifyCallback<
  CardAddRequest,
  CardAddResponse
>("RoadmapCardAdd");

export const moveCard = buildNetlifyCallback<
  CardMoveRequest,
  CardMoveResponse
>("RoadmapCardMove");

export const removeCard = buildNetlifyCallback<
  CardRemoveRequest,
  CardRemoveResponse
>("RoadmapCardRemove");
